<script>
  import { format } from 'svelte-i18n';
  import { Button, Input, Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { RuleBlock } from '@client/components/rule-block';

  import { sanitizeRulenameOnKeyUp } from '@client/utils/sanitize';

  import { PluginParameters } from '../plugin-parameters';
  import { PluginStatus } from '../plugin-status';

  export let plugin;
  export let invalidRulename = false;
  export let isDisabled = false;
  export let invalidFeedback = '';
</script>

<div id="integration-section" class="tab-content">
  <div class="section">
    <h2 class="heading">
      {$format('label.NAME')} <Icon name="help-circle" id="rulename-info" />
    </h2>
    <Tooltip target="rulename-info" placement="top">{$format('label.TOOLTIP.INTEGRATION_RULENAME')}</Tooltip>
    <div class="copy-field" class:invalid={invalidRulename}>
      <RuleBlock text="[[plugin:{plugin.rulename}]]" />
      <Input
        type="text"
        class="rulename"
        placeholder={$format('label.PLACEHOLDER.INPUT', {
          values: { param: $format('label.NAME').toLowerCase() }
        })}
        invalid={isDisabled}
        feedback={invalidFeedback}
        bind:value={plugin.rulename}
        on:keyup={() => (plugin.rulename = sanitizeRulenameOnKeyUp(plugin.rulename))}
      />
    </div>
  </div>
  <div class="section">
    <div class="status-section">
      <h2 class="heading">
        {$format('label.STATUS')} <Icon name="help-circle" id="status-info" />
      </h2>
      <Tooltip target="status-info" placement="top">{$format('label.TOOLTIP.INTEGRATION_STATUS')}</Tooltip>
      <PluginStatus bind:status={plugin.status} />
    </div>
  </div>
  <div class="section">
    <h2 class="heading">{$format('label.PARAMETERS')}</h2>
    <PluginParameters bind:params={plugin.params} />
  </div>
  <div class="section">
    <h2 class="heading">
      {$format('label.FALLBACK_TEXT')} <Icon name="help-circle" id="fallback-text-info" />
    </h2>
    <Tooltip target="fallback-text-info" placement="top">{$format('label.TOOLTIP.INTEGRATION_FALLBACK_TEXT')}</Tooltip>
    <Input
      type="text"
      class="fallback-text"
      placeholder={$format('label.PLACEHOLDER.INPUT', {
        values: { param: $format('label.FALLBACK_TEXT').toLowerCase() }
      })}
      bind:value={plugin.defaulttext}
    />
  </div>
</div>

<style lang="scss" src="./integration.scss"></style>
